module.exports = __webpack_public_path__ + "img/grid.a3ccdf74.png";